"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKLayoutShell = void 0;
var react_1 = __importDefault(require("react"));
var GKMainNav_1 = require("./GKMainNav");
var common_1 = require("../../common");
var __1 = require("../../");
require("./GKLayoutShell.css");
// A note about onNavExpansionChange: yes, we can all agree that it's dumb that
// we switch beteween two strings instead of a boolean. Historically, this
// is because there was going to be more states than just "expanded" and
// "collapsed", but those got cut at some point, and backwards compatibility is
// what it is. If we ever get to a v2, this should obviously be a boolean.
var GKLayoutShell = function (props) {
    // Prop prep
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-layout-shell",
    }), alertsOverlay = _a.alertsOverlay, children = _a.children, qaTag = _a["data-qa"], navContent = _a.navContent, navHome = _a.navHome, navItems = _a.navItems, navLogo = _a.navLogo, navSecondaryItems = _a.navSecondaryItems, onNavExpansionChange = _a.onNavExpansionChange, passthroughProps = __rest(_a, ["alertsOverlay", "children", "data-qa", "navContent", "navHome", "navItems", "navLogo", "navSecondaryItems", "onNavExpansionChange"]);
    // Memoize the main nav
    var mainNav = react_1.default.useMemo(function () {
        var renderNav = navContent || navHome || navItems || navSecondaryItems;
        return renderNav ? (react_1.default.createElement(GKMainNav_1.GKMainNav, { darkMode: true, "data-qa": qaTag + "--main-nav", home: navHome, logo: navLogo, navItems: navItems, secondaryItems: navSecondaryItems }, navContent)) : undefined;
    }, [navContent, navHome, navItems, navLogo, navSecondaryItems, qaTag]);
    // Render all the things
    return (react_1.default.createElement(common_1.WindowSizeManager, null,
        react_1.default.createElement(__1.GKLayoutShellManager, { expansionCallback: onNavExpansionChange },
            react_1.default.createElement(__1.GKAlertsManager, { global: true },
                react_1.default.createElement(common_1.OverlayManager, null,
                    react_1.default.createElement("div", __assign({ "data-qa": qaTag }, passthroughProps),
                        mainNav,
                        react_1.default.createElement(__1.GKLayoutContainer, { alertsContext: "global", alertsOverlay: alertsOverlay, "data-qa": qaTag + "--layout" }, children)))))));
};
exports.GKLayoutShell = GKLayoutShell;
